import React, { type RefObject } from 'react';
import { AnchoredPopover } from '../../../ui/AnchoredPopover';
import { PROFILE_ICONS } from '../../../icons/ProfileIcons';
import type { ProfileIconId } from '../../../../types/supportProfiles';
type IconPickerProps = {
  anchorRef: RefObject<HTMLElement>;
  open: boolean;
  onClose: () => void;
  value: ProfileIconId | null;
  onSelect: (icon: ProfileIconId) => void;
};
export function IconPicker({
  anchorRef,
  open,
  onClose,
  value,
  onSelect
}: IconPickerProps) {
  return <AnchoredPopover anchorRef={anchorRef} open={open} onClose={onClose} width={226} placement="top" align="start" offset={8} data-id="element-527" data-mp="35123gw1rvo8k">
      <div className="rounded-[9px] bg-white p-[10px] shadow-[0_8px_28px_rgba(20,28,38,0.2)] ring-1 ring-black/[0.06]" data-id="element-528" data-mp="2q52msx0lkfrt">
        <p className="pb-[8px] text-[11.5px] font-semibold text-pf-ink" data-id="element-529" data-mp="2v4p016gfdw0m">Choose an icon</p>
        <div role="radiogroup" aria-label="Profile icon" className="grid grid-cols-5 gap-[6px]" data-id="element-530" data-mp="ocxx7s6kluk9">
          {PROFILE_ICONS.map(({
          id,
          label,
          Icon
        }) => {
          const active = value === id;
          return <button key={id} type="button" role="radio" aria-checked={active} aria-label={label} title={label} onClick={() => onSelect(id)} className={`flex h-[36px] w-[36px] items-center justify-center rounded-[7px] border transition-colors duration-150 ${active ? 'border-pf-blue bg-pf-blue-soft text-pf-blue' : 'border-transparent text-pf-ink hover:bg-pf-panel'}`} data-id="element-531" data-mp="2u3ggudc4tghx">
                
                <Icon className="h-[17px] w-[17px]" data-id="element-532" data-mp="2k8oeyxbio7hc" />
              </button>;
        })}
        </div>
      </div>
    </AnchoredPopover>;
}